import InfoTable from './InfoTable';
import EmailButton from './EmailButton';
import useTriggerLevels from '../../hooks/useTriggerLevels';

export default function Info({ stateSchema, locationIDs }) {
  /* eslint-disable no-unused-vars */
  const { triggerLevels, latLon, publicNote } = useTriggerLevels({
    stateSchema,
    locationIDs,
  });
  /* eslint-disable no-unused-vars */

  return (
    <>
      <div className='info'>
        <InfoTable
          locationIDs={locationIDs}
          latLon={latLon}
          publicNote={publicNote}
        />
        <EmailButton
          stateSchema={stateSchema}
          locationIDs={locationIDs}
          latLon={latLon}
          publicNote={publicNote}
        />
        <p className='italicized'>
          This is an experimental product. For project information, please click
          the home icon.
        </p>
      </div>
    </>
  );
}
